module.exports = __webpack_public_path__ + "img/Barlow-Light.2be7a0e0.svg";